/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { Lead } from './Lead';
import {
    LeadFromJSON,
    LeadFromJSONTyped,
    LeadToJSON,
    LeadToJSONTyped,
} from './Lead';
import type { LeadScreenerLeadTagsInnerScreenerTag } from './LeadScreenerLeadTagsInnerScreenerTag';
import {
    LeadScreenerLeadTagsInnerScreenerTagFromJSON,
    LeadScreenerLeadTagsInnerScreenerTagFromJSONTyped,
    LeadScreenerLeadTagsInnerScreenerTagToJSON,
    LeadScreenerLeadTagsInnerScreenerTagToJSONTyped,
} from './LeadScreenerLeadTagsInnerScreenerTag';

/**
 * 
 * @export
 * @interface LeadScreenerLeadTagsInner
 */
export interface LeadScreenerLeadTagsInner {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    facility_id?: string;
    /**
     * 
     */
    lead_id?: string;
    /**
     * 
     */
    tag_id?: string;
    /**
     * 
     */
    comment?: string;
    /**
     * 
     */
    created_by_user_id?: string;
    /**
     * 
     */
    screener_tag?: LeadScreenerLeadTagsInnerScreenerTag;
    /**
     * 
     */
    user?: User;
    /**
     * 
     */
    lead?: Lead;
    /**
     * 
     */
    created_at?: string;
}

/**
 * Check if a given object implements the LeadScreenerLeadTagsInner interface.
 */
export function instanceOfLeadScreenerLeadTagsInner(value: object): value is LeadScreenerLeadTagsInner {
    return true;
}

export function LeadScreenerLeadTagsInnerFromJSON(json: any): LeadScreenerLeadTagsInner {
    return LeadScreenerLeadTagsInnerFromJSONTyped(json, false);
}

export function LeadScreenerLeadTagsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadScreenerLeadTagsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'facility_id': json['facility_id'] == null ? undefined : json['facility_id'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'tag_id': json['tag_id'] == null ? undefined : json['tag_id'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'created_by_user_id': json['created_by_user_id'] == null ? undefined : json['created_by_user_id'],
        'screener_tag': json['screener_tag'] == null ? undefined : LeadScreenerLeadTagsInnerScreenerTagFromJSON(json['screener_tag']),
        'user': json['user'] == null ? undefined : UserFromJSON(json['user']),
        'lead': json['lead'] == null ? undefined : LeadFromJSON(json['lead']),
        'created_at': json['created_at'] == null ? undefined : json['created_at'],
    };
}

export function LeadScreenerLeadTagsInnerToJSON(json: any): LeadScreenerLeadTagsInner {
    return LeadScreenerLeadTagsInnerToJSONTyped(json, false);
}

export function LeadScreenerLeadTagsInnerToJSONTyped(value?: LeadScreenerLeadTagsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'facility_id': value['facility_id'],
        'lead_id': value['lead_id'],
        'tag_id': value['tag_id'],
        'comment': value['comment'],
        'created_by_user_id': value['created_by_user_id'],
        'screener_tag': LeadScreenerLeadTagsInnerScreenerTagToJSON(value['screener_tag']),
        'user': UserToJSON(value['user']),
        'lead': LeadToJSON(value['lead']),
        'created_at': value['created_at'],
    };
}

